import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { Input, Button, Alert } from "antd";
import { useAuth } from "../../context/AuthContext";
import "./Login.css";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  if (user === undefined) return null; // still checking the session
  if (user) return <Navigate to={`/${user.tenant}`} replace />;

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
      // AuthContext's user state updates -> re-render -> redirect above fires
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div>
        <div className="login-brand">
          <div className="login-wordmark">
            bim<em>formation</em>
          </div>
          <div className="login-tagline">Digital Infrastructure Platform</div>
        </div>

        <form className="login-card" onSubmit={handleSubmit}>
          <div className="login-card-title">Sign in</div>
          <p className="login-card-sub">Enter your work email to continue.</p>

          {error && (
            <Alert className="login-error" type="error" title={error} showIcon />
          )}

          <div className="login-field">
            <label htmlFor="login-email">Email</label>
            <Input
              id="login-email"
              type="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
            />
          </div>

          <div className="login-field">
            <label htmlFor="login-password">Password</label>
            <Input.Password
              id="login-password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <Button
            className="login-submit"
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            Sign in
          </Button>

          <div className="login-footer">Access is by invitation only.</div>
        </form>

        <a
          className="login-creator-link"
          href="https://www.bimformation.net/leventtasci/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Built by Levent Tasci
          <span className="login-creator-arrow">↗</span>
        </a>
      </div>
    </div>
  );
}
